export default __webpack_public_path__ + "static/media/forgot-password-illustration.eb52edcb.svg";